var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import styled from "styled-components";
import colors from "../../designSystem/colors";
import { ProductList } from "../Product/types";
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-wrap: wrap;\n  width: ", "px;\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n  width: ", "px;\n"])), function (props) { return props.width; });
var LightBar = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  height: ", "px;\n  width: 100%;\n  background: ", ";\n  box-shadow: 8px 16px 80px\n    ", ";\n  border-radius: 2px;\n  ", "\n\n  &:not(:first-child) {\n    margin-top: ", "px;\n  }\n"], ["\n  height: ", "px;\n  width: 100%;\n  background: ", ";\n  box-shadow: 8px 16px 80px\n    ", ";\n  border-radius: 2px;\n  ", "\n\n  &:not(:first-child) {\n    margin-top: ", "px;\n  }\n"])), function (props) { return props.height; }, function (props) {
    return props.active ? colors.products[props.product] : "#FFFFFF0A";
}, function (props) { return (props.active ? colors.products[props.product] : "none"); }, function (props) {
    return "transition: background " + props.interval + "ms ease-in-out, box-shadow " + props.interval + "ms ease-in-out;";
}, function (props) { return props.spacing; });
var TrafficLight = function (_a) {
    var active = _a.active, _b = _a.interval, interval = _b === void 0 ? 350 : _b, _c = _a.lightBarConfig, lightBarConfig = _c === void 0 ? {
        width: 200,
        height: 16,
        spacing: 24,
    } : _c;
    var _d = useState(), activeIndex = _d[0], setActiveIndex = _d[1];
    useEffect(function () {
        if (!active) {
            setActiveIndex(undefined);
            return;
        }
        var timeInterval = setInterval(function () {
            setActiveIndex(function (curr) {
                return curr !== undefined ? (curr + 1) % 4 : 0;
            });
        }, interval);
        return function () { return clearInterval(timeInterval); };
    }, [active, interval]);
    return (_jsx(Container, __assign({ width: lightBarConfig.width }, { children: ProductList.map(function (product, index) { return (_jsx(LightBar, { height: lightBarConfig.height, spacing: lightBarConfig.spacing, product: product, active: activeIndex === index, interval: interval }, index)); }) }), void 0));
};
export default TrafficLight;
var templateObject_1, templateObject_2;
//# sourceMappingURL=TrafficLight.js.map